<mat-card-content class="w-100-p mb-0">
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="h-full" *ngIf="!charts?.length">
            <div fxLayout="row" fxLayoutAlign="flex-start space-between" class="chart-title-wrapper mb-12">
                <div
                    fxLayoutAlign="center center"
                    class="icon-wrapper mr-8"
                    [ngStyle]="{
                        background: '#F0BFDF',
                        fill: '#C5639C'
                    }"
                >
                    <mat-icon svgIcon="dashboard_grow_daily_posting_link_followed"></mat-icon>
                </div>
                <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0" *ngIf="!hideChartTitle">
                    {{ 'TENANT_DASHBOARD.CHART.monthly_active_days' | translate }}
                    <span
                        class="ml-8 info-icon"
                        fxLayoutAlign="center center"
                        matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.monthly_active_days' | translate }}"
                        matTooltipPosition="above"
                        tabindex="0"
                    >
                        i
                    </span>
                </label>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto" class="bg-zinc-50">
                <span class="text-xs leading-5 text-gray-600 text-center tracking-widest uppercase" tabindex="0">
                    {{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}
                </span>
            </div>
        </div>

        <div class="chart-wrapper">
            <ng-container class="h-full" *ngFor="let chart of charts">
                <div *ngIf="chart.chartId === TenantDashboardChartId.MonthlyActiveDays; else noProgress">
                    <div fxLayout="row" fxLayoutAlign="flex-start space-between" class="chart-title-wrapper mb-12">
                        <div
                            fxLayoutAlign="center center"
                            class="icon-wrapper mr-8"
                            [ngStyle]="{
                                background: '#F0BFDF',
                                fill: '#C5639C'
                            }"
                        >
                            <mat-icon svgIcon="dashboard_grow_daily_posting_link_followed"></mat-icon>
                        </div>
                        <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0" *ngIf="!hideChartTitle">
                            {{ 'TENANT_DASHBOARD.CHART.' + chart.chartId | translate }}
                            <span class="mx-8">{{ yearlyActiveDays }}</span>
                            <span
                                class="ml-8 info-icon"
                                fxLayoutAlign="center center"
                                matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.' + chart.chartId | translate }}"
                                matTooltipPosition="above"
                                tabindex="0"
                            >
                                i
                            </span>
                        </label>
                    </div>
                    <div fxLayoutAlign="center center">
                        <div class="bar-chart-container">
                            <canvas baseChart [class]="chart.type" [data]="chart.chartData" [options]="chart.options" [type]="chart.type"> </canvas>
                        </div>
                    </div>
                </div>
                <ng-template #noProgress>
                    <div fxLayout="column" class="h-full" *ngIf="charts.length === 1">
                        <div fxLayout="row" fxLayoutAlign="flex-start space-between" class="chart-title-wrapper mb-12">
                            <div
                                fxLayoutAlign="center center"
                                class="icon-wrapper mr-8"
                                [ngStyle]="{
                                    background: '#F0BFDF',
                                    fill: '#C5639C'
                                }"
                            >
                                <mat-icon svgIcon="dashboard_grow_daily_posting_link_followed"></mat-icon>
                            </div>
                            <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0" *ngIf="!hideChartTitle">
                                {{ 'TENANT_DASHBOARD.CHART.monthly_active_days' | translate }}
                                <span class="mx-8">{{ yearlyActiveDays }}</span>
                                <span
                                    class="ml-8 info-icon"
                                    fxLayoutAlign="center center"
                                    matTooltip="{{ 'TEAMS.CHART.TOOLTIP.monthly_active_days' | translate }}"
                                    matTooltipPosition="above"
                                    tabindex="0"
                                >
                                    i
                                </span>
                            </label>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto" class="bg-zinc-50">
                            <span class="text-xs leading-5 text-gray-600 text-center tracking-widest uppercase" tabindex="0">
                                {{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}
                            </span>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </div>
</mat-card-content>
